import { ProjectStatusFilter } from '../enums';

export const ProjectStatusFiltersConstant: ProjectStatusFilter[] = [
  ProjectStatusFilter.ALL_ACTIVE_PROJECTS,
  ProjectStatusFilter.SIZING_COMPLETED,
  ProjectStatusFilter.VALIDATED,
  ProjectStatusFilter.ARCHIVED,
];
